import {
	applicationViewStatusNamespace,
	digitalOfficeNamespace,
	fishCardModalNamespace,
	headerNamespace,
	loginRegistrationNamespace,
	navigationNamespace,
	userSuggestNamespace,
} from '@/i18n/namespace';

import { applicationViewStatusResource } from './application-view-status';
import { digitalOfficeResource } from './digital-office';
import { fishCardModalResource } from './fish-card-modal';
import { headerResource } from './header';
import { loginRegistrationResource } from './login-registration';
import { navigationResource } from './navigation';
import { userSuggestResource } from './user-suggest';

export const ruResource = {
	[headerNamespace]: headerResource,
	[userSuggestNamespace]: userSuggestResource,
	[navigationNamespace]: navigationResource,
	[fishCardModalNamespace]: fishCardModalResource,
	[digitalOfficeNamespace]: digitalOfficeResource,
	[loginRegistrationNamespace]: loginRegistrationResource,
	[applicationViewStatusNamespace]: applicationViewStatusResource,
};
